module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('app-navigation'), _vm._v(" "), _c('div', {
    staticClass: "row player"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.$route.params.ytid,
      "player-width": _vm.playerWidth,
      "player-height": _vm.playerHeight,
      "player-vars": _vm.playerVars
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.back
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de19603c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 90
// module chunks = 0